import Vue from "vue";
const state = () => ({
  Superviseurs: [],
  ////////////////
  disable_next: false,
  disable_prev: false,
  //Save first document in snapshot of items received
  firstInResponse: [],
  //Save last document in snapshot of items received
  lastInResponse: [],
  //Keep the array of first document of previous pages
  prev_start_at: [],
  //Maintain the count of clicks on Next Prev button
  pagination_clicked_count: 0,
  paginationSize: 10,
  field: "email",
  whereField: "role",
  whereValue: "superviseur",
  collection: "users",
});

const mutations = {
  SET_LISTE(state, payload) {
    state.Superviseurs = payload;
  },
  ///////////////////
  SET_DISABLE_NEXT(state, payload) {
    state.disable_next = payload;
  },
  SET_DISABLE_PREV(state, payload) {
    state.disable_prev = payload;
  },
  SET_firstInResponse(state, payload) {
    state.firstInResponse = payload;
  },
  SET_lastInResponse(state, payload) {
    state.lastInResponse = payload;
  },
  SET_prev_start_at(state, payload) {
    state.prev_start_at = payload;
  },
  SET_pagination_clicked_count(state, payload) {
    state.pagination_clicked_count = payload;
  },
  SET_prev_start_at(state, payload) {
    state.prev_start_at = payload;
  },
};

const actions = {
  async Get({ commit, dispatch }) {
    // start requête
    commit("SET_LISTE", []);

    commit("Loading/START_BUSY_STATE", "Superviseurs Get", { root: true });

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection(this.state.Superviseurs.collection)
      .where(
        this.state.Superviseurs.whereField,
        "==",
        this.state.Superviseurs.whereValue
      )
      .orderBy(this.state.Superviseurs.field)
      .limit(this.state.Superviseurs.paginationSize)
      .get()
      .then(
        (snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
            commit("Pending/START_PENDING_STATE", null, { root: true });
          } else {
            console.log("tout est synchronisé dans Superviseurs");
            commit("Pending/END_PENDING_STATE", null, { root: true });
          }
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          commit("SET_prev_start_at", []);

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_firstInResponse", elems[0]);
            commit("SET_lastInResponse", elems[elems.length - 1]);
            commit("SET_pagination_clicked_count", 0);
            commit("SET_DISABLE_NEXT", false);
            commit("SET_DISABLE_PREV", false);

            //Push first item to use for Previous action
            let prev_start_at = [];
            prev_start_at.push(elems[0]);
            commit("SET_prev_start_at", prev_start_at);

            commit("SET_LISTE", elems);
            commit("Loading/END_BUSY_STATE", "Superviseurs.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          commit("Loading/END_BUSY_STATE", "Superviseurs.store.js", {
            root: true,
          });
        }
      );
  },

  async nextPage({ commit }) {
    let elems = [];
    let self = this;

    commit("SET_DISABLE_NEXT", true);
    await this._vm.$firebase
      .firestore()
      .collection(this.state.Superviseurs.collection)
      .where(
        this.state.Superviseurs.whereField,
        "==",
        this.state.Superviseurs.whereValue
      )
      .orderBy(this.state.Superviseurs.field)
      .startAfter(this.state.Superviseurs.lastInResponse.email)
      .limit(this.state.Superviseurs.paginationSize)
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          commit("SET_LISTE", elems);

          if (!elems.length) {
            commit("SET_DISABLE_NEXT", true);
          }

          commit("SET_firstInResponse", elems[0]);
          commit("SET_lastInResponse", elems[elems.length - 1]);

          commit(
            "SET_pagination_clicked_count",
            self.state.Superviseurs.pagination_clicked_count++
          );
          self.state.Superviseurs.pagination_clicked_count++;
          commit("SET_DISABLE_PREV", false);
          //Push first item to use for Previous action
          let prev_start_at = this.state.Superviseurs.prev_start_at;
          prev_start_at.push(elems[0]);
          commit("SET_prev_start_at", prev_start_at);
          commit("SET_DISABLE_NEXT", false);
        },
        (error) => {
          console.log(error);
          commit("SET_DISABLE_NEXT", false);
        }
      );
  },

  async prevPage({ commit }) {
    let prev_start_at = this.state.Superviseurs.prev_start_at;
    if (
      prev_start_at.length >
      this.state.Superviseurs.pagination_clicked_count + 1
    )
      prev_start_at.splice(prev_start_at.length - 2, prev_start_at.length - 1);
    let get_prev_startAt =
      prev_start_at[this.state.Superviseurs.pagination_clicked_count - 1];
    //console.log(get_prev_startAt);
    let elems = [];
    let self = this;
    commit("SET_DISABLE_PREV", true);
    await this._vm.$firebase
      .firestore()
      .collection(this.state.Superviseurs.collection)
      .where(
        this.state.Superviseurs.whereField,
        "==",
        this.state.Superviseurs.whereValue
      )
      .orderBy(this.state.Superviseurs.field)
      .startAt(get_prev_startAt.email)
      .endBefore(self.state.Superviseurs.firstInResponse.email)
      .limit(this.state.Superviseurs.paginationSize)
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          commit("SET_LISTE", elems);

          if (!elems.length) {
            commit("SET_DISABLE_NEXT", true);
          }

          commit("SET_firstInResponse", elems[0]);
          commit("SET_lastInResponse", elems[elems.length - 1]);

          //Maintaing page no.
          commit(
            "SET_pagination_clicked_count",
            self.state.Superviseurs.pagination_clicked_count--
          );
          self.state.Superviseurs.pagination_clicked_count--;

          //Pop not required value in array
          let prev_start_at = self.state.Superviseurs.prev_start_at;
          prev_start_at.forEach((element) => {
            if (elems[0].id == element.id) {
              element = null;
            }
          });
          commit("SET_prev_start_at", prev_start_at);

          //Enable buttons again
          commit("SET_DISABLE_PREV", false);
          commit("SET_DISABLE_NEXT", false);
        },
        (error) => {
          console.log(error);
          commit("SET_DISABLE_PREV", false);
        }
      );
  },
};

const getters = {
  Superviseurs: (state) => {
    return state.Superviseurs;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
